import styled from 'styled-components';

import { HOME } from '../../../../theme/tokens';

export type DeltaVariant = 'emerald' | 'success' | 'down';

/** Foreground + fill per variant. The down variant overrides any positive tone. */
export const DELTA_COLORS: Record<DeltaVariant, { fg: string; bg: string }> = {
  emerald: { fg: HOME.emerald, bg: HOME.emeraldBg },
  success: { fg: HOME.success, bg: HOME.successBg },
  down: { fg: HOME.danger, bg: HOME.dangerBg },
};

export const Pill = styled.span<{ $variant: DeltaVariant }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-weight: 400;
  line-height: 1;
  padding: 3px 7px;
  border-radius: 8px;
  white-space: nowrap;
  color: ${(p) => DELTA_COLORS[p.$variant].fg};
  background: ${(p) => DELTA_COLORS[p.$variant].bg};
`;
